import React, { useEffect } from 'react';
import { useLogout } from '@refinedev/core';
import { Spin } from 'antd';

const LogoutPage: React.FC = () => {
  const { mutate: logout } = useLogout();

  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '16px'
    }}>
      <Spin size="large" />
      <div>Logging out...</div>
    </div>
  );
};

export default LogoutPage;